@if (
  {
    open: open$ | async,
    detailsPanelOverlayEnabled: detailsPanelOverlayEnabled$ | async,
    mazChatEnabled: mazChatEnabled$ | async,
    isMazChatOpen: isMazChatOpen$ | async,
    isMazChatExpanded: isMazChatExpanded$ | async,
    isMazSessionInProgress: isMazSessionInProgress$ | async,
    canAccessMazCDQ: canAccessMazCDQ$ | async,
    rnaMeetingPrepEnabled: rnaMeetingPrepEnabled$ | async,
    sideDetailExpanded: sideDetailExpanded$ | async,
    webMazGlobalEntryEnabled: webMazGlobalEntryEnabled$ | async,
  };
  as state
) {
  <div id="main-layout">
    <div
      class="content terrafy-content"
      [style.overflow]="overflowType"
      [class.hasOpenPanel]="state.open && !state.detailsPanelOverlayEnabled">
      <ng-content select="[page-sidebar]" />
      <!-- See SCSS definition of with-bottom-padding and MainLayoutService for more info about edge cases of bottom padding -->
      <div class="page-without-sidebar with-bottom-padding" id="main-page-content" [style.overflow]="overflowType">
        <ng-content select="[page-banner]" />
        <ng-content select="[billing-page-banner]" />
        <ng-content select="[subscription-renewal-banner]" />
        <ng-content select="[manager-permission-changes-banner]" />
        <ninety-main-header
          [inMeeting]="inMeeting"
          [inFeedback]="inFeedback"
          [isMobile]="isMobile"
          [isConversation]="isConversation" />
        <div class="page-and-detail-wrapper">
          <!-- This template variable exposes the scrollable page content for the ScrollSpy directive -->
          <div #pageContent class="page-wrapper">
            <ng-content select="[page-content]" />
          </div>
        </div>
        @if (showGettingStartedGuide$ | async) {
          @defer (on immediate) {
            <ninety-getting-started-guide />
          }
        }
      </div>
      @if (state.mazChatEnabled) {
        <div
          class="side-details-expandable"
          [ngClass]="{
            'terrafy-sidebar--overlay': state.detailsPanelOverlayEnabled,
            'side-details-expandable--open': state.isMazChatOpen,
            'side-details-expandable--open-expanded': state.isMazChatOpen && state.isMazChatExpanded,
            'side-details-expandable--side-detail-expanded': state.sideDetailExpanded,
            'side-details-expandable--minimizing': isMinimizing,
          }">
          <aside
            class="detail-wrapper terrafy-sidebar"
            [class.terrafy-sidebar--overlay]="state.detailsPanelOverlayEnabled"
            [class.detail-wrapper--overlay]="state.detailsPanelOverlayEnabled"
            [class.hidden]="!state.open"
            [class.detail-card-v2-wrp]="isV2Detail$ | async"
            [class.enable-scrollbar]="(disableScrollbar$ | async) !== true"
            [class.terrafy-sidebar--maz]="state.isMazChatOpen"
            [class.terrafy-sidebar--expanded]="state.isMazChatOpen && state.isMazChatExpanded"
            [class.terrafy-sidebar--side-detail-expanded]="state.sideDetailExpanded">
            <router-outlet name="detail" (activate)="onActivateDetail()" (deactivate)="onDeactivateDetail()" />
          </aside>
        </div>
      }
      @if (!state.mazChatEnabled) {
        <aside
          class="detail-wrapper terrafy-sidebar"
          [class.terrafy-sidebar--overlay]="state.detailsPanelOverlayEnabled"
          [class.detail-wrapper--overlay]="state.detailsPanelOverlayEnabled"
          [class.hidden]="!state.open"
          [class.detail-card-v2-wrp]="isV2Detail$ | async"
          [class.enable-scrollbar]="(disableScrollbar$ | async) !== true"
          [class.terrafy-sidebar--side-detail-expanded]="state.sideDetailExpanded">
          <router-outlet name="detail" (activate)="onActivateDetail()" (deactivate)="onDeactivateDetail()" />
        </aside>
      }
      @if (spinnerService.primary$ | async) {
        <mat-spinner class="main-spinner" color="accent" />
      }
      @if (state.rnaMeetingPrepEnabled) {
        <ninety-meeting-prep-panel
          [class.maz-offset]="state.isMazChatOpen"
          [class.maz-offset--expanded]="state.isMazChatOpen && state.isMazChatExpanded"
          [class.maz-offset--side-detail]="state.isMazChatOpen && state.sideDetailExpanded" />
      }
    </div>
  </div>
}
